// pages/TaxSummary.jsx
import React, { useState } from "react";
import { FaFilePdf, FaLock } from "react-icons/fa";
import InDevelopment from "../development/index";

const taxData = {
  2025: { gross: 540000, deductions: 40000 },
  2024: { gross: 500000, deductions: 38000 },
  2023: { gross: 460000, deductions: 35000 },
};

function TaxSummary() {
  const years = Object.keys(taxData).sort((a, b) => b - a);
  const [selectedYear, setSelectedYear] = useState(years[0]);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [password, setPassword] = useState("");

  const summary = taxData[selectedYear];
  const net = summary.gross - summary.deductions;

  const handleDownload = () => {
    setShowPasswordModal(true);
  };

  const confirmDownload = () => {
    if (!password) return alert("⚠ Password required for download.");
    alert(`📄 PDF for ${selectedYear} downloaded with password protection.`);
    setShowPasswordModal(false);
  };

  return (
    <>
      <InDevelopment />
{/*     
    <div className=" mx-auto p-6 space-y-6 ">
      <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
       
      </h2>

      <div className="flex flex-col sm:flex-row gap-4 items-center">
        <label htmlFor="year" className="text-gray-600 font-medium">
          Select Year:
        </label>
        <select
          id="year"
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
          className="border border-gray-300 px-3 py-2 rounded-md shadow-sm focus:ring focus:ring-blue-200 transition"
        >
          {years.map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-blue-50 p-4 rounded-xl shadow hover:shadow-md transition">
          <p className="text-gray-500 text-sm">Gross Earnings</p>
          <p className="text-lg font-bold text-blue-800">${summary.gross.toLocaleString()}</p>
        </div>
        <div className="bg-yellow-50 p-4 rounded-xl shadow hover:shadow-md transition">
          <p className="text-gray-500 text-sm">Deductions</p>
          <p className="text-lg font-bold text-yellow-800">${summary.deductions.toLocaleString()}</p>
        </div>
        <div className="bg-green-50 p-4 rounded-xl shadow hover:shadow-md transition">
          <p className="text-gray-500 text-sm">Net Income</p>
          <p className="text-lg font-bold text-green-800">${net.toLocaleString()}</p>
        </div>
      </div>

      <button
        onClick={handleDownload}
        className="flex items-center gap-2 bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-700 hover:to-blue-600 text-white px-5 py-2 rounded-md shadow hover:shadow-lg transition"
      >
        <FaFilePdf />
        Download PDF
      </button>

      <div className="mt-6">
        <h3 className="font-semibold mb-3 text-gray-700">📚 Previous Years</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm border border-gray-200 rounded-xl">
            <thead>
              <tr className="bg-gray-100 text-gray-600">
                <th className="border px-3 py-2">Year</th>
                <th className="border px-3 py-2">Gross</th>
                <th className="border px-3 py-2">Deductions</th>
                <th className="border px-3 py-2">Download</th>
              </tr>
            </thead>
            <tbody className="text-gray-700">
              {years.map((year) => (
                <tr key={year} className="hover:bg-gray-50 transition">
                  <td className="border px-3 py-2">{year}</td>
                  <td className="border px-3 py-2">${taxData[year].gross.toLocaleString()}</td>
                  <td className="border px-3 py-2">${taxData[year].deductions.toLocaleString()}</td>
                  <td className="border px-3 py-2 text-center">
                    <button
                      onClick={() => setSelectedYear(year) || handleDownload()}
                      className="text-blue-600 hover:underline flex items-center gap-1 mx-auto"
                    >
                      <FaFilePdf /> Download
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showPasswordModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-2xl shadow-xl w-full max-w-sm space-y-4">
            <h3 className="text-lg font-semibold flex items-center gap-2">
              <FaLock /> Enter Download Password
            </h3>
            <input
              type="password"
              className="w-full border border-gray-300 px-3 py-2 rounded-md shadow-sm focus:ring focus:ring-blue-200 transition"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <div className="flex justify-end gap-2">
              <button
                className="text-gray-600 hover:text-gray-800 transition"
                onClick={() => setShowPasswordModal(false)}
              >
                Cancel
              </button>
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded-md shadow"
                onClick={confirmDownload}
              >
                Download
              </button>
            </div>
          </div>
        </div>
      )}
    </div> */}
    </>
  );
}

export default TaxSummary;
